@import 'styles/variables';

.modal {
  display: flex;
  flex-direction: column;
  background: var(--light-80);
  backdrop-filter: blur(25px);
  border-radius: 20px;
  box-shadow: 0px 8px 37px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.header {
  padding: 20px 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.pricingSection {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.currentPlanRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.planLabel {
  font-family: 'Sohne';
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-80);
  letter-spacing: 0.48px;
  line-height: 1.4;
}

.planName {
  background: var(--Growth-Plan, linear-gradient(268deg, #65cefe 1.28%, #0c7dff 99.59%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 500;
  font-family: 'Sohne';
  font-size: 16px;
  letter-spacing: 0.48px;
  line-height: 1.4;
}

.price {
  font-family: 'Sohne';
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-80);
  letter-spacing: 0.32px;
  line-height: 1.4;
  text-align: right;
  width: 100px;
}

.addonRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.addonLabel {
  font-family: 'Sohne';
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-80);
  letter-spacing: 0.48px;
  line-height: 1.4;
}

.totalRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 11px 0 10px;
  border-top: 1px solid var(--dark-4);
}

.totalLabel {
  font-family: 'Sohne';
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-80);
  letter-spacing: 0.48px;
  line-height: 1.4;
}

.totalPrice {
  font-family: 'Sohne';
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-80);
  letter-spacing: 0.32px;
  line-height: 1.35;
  text-align: right;
}

.prorationNotice {
  font-family: 'Sohne';
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-60);
  letter-spacing: 0.28px;
  line-height: 1.5;
}

.errorNotice {
  padding: 12px;
  background: rgba(221, 71, 64, 0.1);
  border-radius: 6px;
}

.cancelNotice {
  font-family: 'Sohne';
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-60);
  letter-spacing: 0.28px;
  line-height: 1.5;

  strong {
    font-weight: 600;
    color: var(--dark-80);
  }
}

.cancelInfo {
  font-family: 'Sohne';
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-40);
  letter-spacing: 0.28px;
  line-height: 1.5;
}

.paymentMethodSection {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  gap: 8px;

  [data-autopilot-system-redesign='on'] & {
    padding-bottom: 0;
  }
}
